// babel core-js@3
import '../../modules/babel';

import * as util from '../../modules/util';
import restApi from '../../modules/restApi';

// Class Definition
const KTLoginGeneral = (() => {
  const login = $('#kt_login');

  let isNeedAddButton = false;

  const showErrorMsg = (form, type, msg) => {
    const alert = $(`
      <div class="alert alert-${type} alert-dismissible" role="alert">
        <div class="alert-text">${msg}</div>
        <div class="alert-close">
          <i class="flaticon2-cross kt-icon-sm" data-dismiss="alert"></i>
        </div>
      </div>
    `);

    form.find('.alert').remove();
    alert.prependTo(form);
    // alert.animateClass('fadeIn animated');
    KTUtil.animateClass(alert[0], 'fadeIn animated');
    alert.find('span').html(msg);
  };

  const removeErrorMsg = () => {
    $('.alert').fadeOut();
  };

  const generateSecret = () => {
    util.customFetch(restApi.userMfaGenerateSecret, (data) => {
      const userId = data.userId;
      const secretKey = data.secretKey;
      const mfaType = $('#mfa_modal_mfa_type').val();
      const type = {
        L: 'login',
        A: 'admin'
      }

      // QR 코드 Generate
      $('#qrcodePlaceHolder').html(util.generateQRCode(`otpauth://totp/${userId}@fitCloud.${type[mfaType]}?secret=${secretKey}`));

      // Secret 키 Hidden에 저장
      $('#mfa_secret_key').val(secretKey);
      $('#mfa_secret_key_text').html(secretKey)

      $('#mfa_user_id').val(userId);
      $('#mfa_device_name').html(`${userId}@fitCloud.${type[mfaType]}`);
    });
  }

  // Private Functions
  const displaySignUpForm = () => {
    login.removeClass('kt-login--forgot');
    login.removeClass('kt-login--signin');
    login.removeClass('kt-login--mfa');

    login.addClass('kt-login--signup');
    KTUtil.animateClass(login.find('.kt-login__signup')[0], 'flipInX animated');
  };

  const displayMfaForm = (isNeedAddButton) => {
    login.removeClass('kt-login--forgot');
    login.removeClass('kt-login--signin');
    login.removeClass('kt-login--signup');

    login.addClass('kt-login--mfa');

    if(isNeedAddButton){
      $('#mfa_generate_link').show();
      $('#kt_login_mfa_submit').prop('disabled', true);
    }else{
      $('#mfa_generate_link').hide();
      $('#kt_login_mfa_submit').prop('disabled', false);

    }

    $("[name='mfaCode']").focus();
    KTUtil.animateClass(login.find('.kt-login__mfa')[0], 'flipInX animated');
  }

  const displaySignInForm = () => {
    login.removeClass('kt-login--forgot');
    login.removeClass('kt-login--signup');
    login.removeClass('kt-login--mfa');

    login.addClass('kt-login--signin');
    KTUtil.animateClass(login.find('.kt-login__signin')[0], 'flipInX animated');
    // login.find('.kt-login__signin').animateClass('flipInX animated');
  };

  const displayForgotForm = () => {
    login.removeClass('kt-login--signin');
    login.removeClass('kt-login--signup');
    login.removeClass('kt-login--mfa');

    login.addClass('kt-login--forgot');
    // login.find('.kt-login--forgot').animateClass('flipInX animated');
    KTUtil.animateClass(login.find('.kt-login__forgot')[0], 'flipInX animated');
  };

  const handleFormSwitch = () => {
    $('#kt_login_forgot').click((e) => {
      e.preventDefault();
      displayForgotForm();
    });

    $('#kt_login_forgot_cancel').click((e) => {
      e.preventDefault();
      displaySignInForm();
    });

    $('#kt_login_mfa_cancel').click((e) => {
      e.preventDefault();
      displaySignInForm();
    });

    $('#kt_login_signup').click((e) => {
      e.preventDefault();
      displaySignUpForm();
    });

    $('#kt_login_signup_cancel').click((e) => {
      e.preventDefault();
      displaySignInForm();
    });
  };

  const handleSignInFormSubmit = () => {
    $('#kt_login_signin_submit').click(function a(e) {
      removeErrorMsg();
      e.preventDefault();
      const btn = $(this);
      const form = $(this).closest('form');
      const formResult = $(form).serializeObject();

      if (!form.valid()) {
        return;
      }

      btn.addClass('kt-spinner kt-spinner--right kt-spinner--sm kt-spinner--light').attr('disabled', true);

      util.customFetch(restApi.checkMfa, (res) => {
        if (res.result.result) {
          window.location = res.redirectURL;
        } else if(!res.result.validId){
          btn.removeClass('kt-spinner kt-spinner--right kt-spinner--sm kt-spinner--light').attr('disabled', false);
          showErrorMsg(form, 'danger', '입력한 사용자 이름이 잘못되었습니다. 정보를 확인하고 다시 시도하세요.');
        } else if(!res.result.validLogin) {
          btn.removeClass('kt-spinner kt-spinner--right kt-spinner--sm kt-spinner--light').attr('disabled', false);
          showErrorMsg(form, 'danger', '비밀번호가 잘못되었습니다. 정보를 확인하고 다시 시도하세요.');
        } else if (res.result.mfaInit && res.result.validLogin) {
          btn.removeClass('kt-spinner kt-spinner--right kt-spinner--sm kt-spinner--light').attr('disabled', false);
          isNeedAddButton = res.result.isNeedAddButton;
          displayMfaForm(isNeedAddButton);
        } else {
          btn.removeClass('kt-spinner kt-spinner--right kt-spinner--sm kt-spinner--light').attr('disabled', false);
          showErrorMsg(form, 'danger', '입력한 사용자 이름 또는 비밀번호가 잘못되었습니다. 정보를 확인하고 다시 시도하세요.');
        }
      }, formResult, 'POST', true);
    });
  };

  const handleMfaFormSubmit = () => {
    $('#kt_login_mfa_submit').click(function a(e) {
      e.preventDefault();
      const btn = $(this);
      const form = $(this).closest('form');
      const formResult = $(form).serializeObject();

      formResult.userId = $('#loginUserId').val();
      formResult.password = $('#loginPassword').val();

      if (!form.valid()) {
        return;
      }

      // 숫자가 아닌경우 return
      if(isNaN(parseFloat(formResult.mfaCode))) {
        showErrorMsg(form, 'danger', '인증코드가 잘못되었습니다. 정보를 확인하고 다시 시도하세요.');
        return;
      }
      btn.addClass('kt-spinner kt-spinner--right kt-spinner--sm kt-spinner--light').attr('disabled', true);

      util.customFetch(restApi.login, (res) => {
        if (res.result.result) {
          window.location = res.redirectURL;
        } else {
          btn.removeClass('kt-spinner kt-spinner--right kt-spinner--sm kt-spinner--light').attr('disabled', false);
          showErrorMsg(form, 'danger', '인증코드가 잘못되었습니다. 정보를 확인하고 다시 시도하세요.');
        }
      }, formResult, 'POST', true);
    });

    $('#mfa_modal_form').validate({
      rules: {
        mfa_code_number: {
          required : true,
          minlength : 6,
          digits : true
        }
      },
      invalidHandler() {
        KTUtil.scrollTop();
      },

      submitHandler(form) {
        // 폼데이터 Object 변환
        const formResult = $(form).serializeObject();

        swal.fire({
          title: 'Are you sure?',
          type: 'warning',
          text: 'MFA Device를 등록하시겠습니까?',
          showCancelButton: true,
          confirmButtonText: 'Yes, add it!',

          showLoaderOnConfirm: true,
          preConfirm: () => util.returnCustomFetch(restApi.userMfa, formResult, 'PUT'),
        }).then((result) => {
          if (result.value) {
            if (result.value.state) {
              swal.fire(
                  'Changed!',
                  'MFA Device가 등록되었습니다!',
                  'success',
              ).then(() => {
                $('#addMfa_modal').modal('toggle');
                displayMfaForm(false);
              });
            } else {
              swal.fire(
                  'failed!',
                  result.value.message,
                  'warning',
              )
            }
          }
        });
        return false;
      },
    });
  };

  const handleSignUpFormSubmit = () => {
    $('#kt_login_signup_submit').click(function b(e) {
      e.preventDefault();

      const btn = $(this);
      const form = $(this).closest('form');
      const formResult = $(form).serializeObject();

      form.validate({
        rules: {
          email: {
            required: true,
            email: true,
          },
        },
      });

      if (!form.valid()) {
        return;
      }

      btn.addClass('kt-spinner kt-spinner--right kt-spinner--sm kt-spinner--light').attr('disabled', true);

      const headers = new Headers();
      headers.append('FITCLOUDSESSION', util.getSession());
      headers.append('loginToken', sessionStorage.getItem("loginToken"));
      const formData = new FormData();
      Object.keys(formResult).forEach((key) => {
        formData.append(key, formResult[key]);
      });
      const myInit = {
        method: 'POST',
        headers,
        body: formData,
      };

      const myRequest = new Request(restApi.idInfo, myInit);

      // util.customFetch사용하지 못하는 이유: result가 없음 대신 message가 있음
      window.fetch(myRequest)
        .then((response) => {
          if (response.ok) return response.json();
          throw new Error('Network response was not ok.');
        })
        .then((data) => {
          if ((data.message).includes('does not exist')) {
            btn.removeClass('kt-spinner kt-spinner--right kt-spinner--sm kt-spinner--light').attr('disabled', false); // remove
            form.clearForm(); // clear form
            form.validate().resetForm(); // reset validation states

            showErrorMsg($('.kt-findPwd'), 'danger', '등록되지 않은 아이디입니다.');
          } else {
            // similate 2s delay
            new Promise((resolve) => {
              btn.removeClass('kt-spinner kt-spinner--right kt-spinner--sm kt-spinner--light').attr('disabled', false); // remove
              form.clearForm(); // clear form
              form.validate().resetForm(); // reset validation states

              // display signup form
              /*   displaySignInForm();
              const signInForm = login.find('.kt-login__signin form');
              signInForm.clearForm();
              signInForm.validate().resetForm(); */
              $('.kt-findId').hide();
              resolve(data);
            }).then((data) => {
              $('.id_desc').append(`<div class="kt-portlet__body p-5">
              <div class="form-group form-group-last">
              <div class="alert alert-outline-info" role="alert">
                <div class="alert-icon"><i class="flaticon-warning"></i></div>
                <div class="alert-text font-weight-bold">
                  등록된 ID는 [${data.message}] 입니다.
                </div>
              </div>
            </div>
            </div>`);
            });
          }
        }).catch(error => util.errorHandling(error));
    });
  };

  const handleForgotFormSubmit = () => {
    $('#kt_login_forgot_submit').click(function c(e) {
      e.preventDefault();

      const btn = $(this);
      const form = $(this).closest('form');
      const formResult = $(form).serializeObject();

      form.validate({
        rules: {
          email: {
            required: true,
            email: true,
          },
		  name: true,
        },
      });

      if (!form.valid()) {
        return;
      }

      btn.addClass('kt-spinner kt-spinner--right kt-spinner--sm kt-spinner--light').attr('disabled', true);

      const headers = new Headers();
      headers.append('FITCLOUDSESSION', util.getSession());
      headers.append('loginToken', sessionStorage.getItem("loginToken"));
      const formData = new FormData();
      Object.keys(formResult).forEach((key) => {
        formData.append(key, formResult[key]);
      });
      const myInit = {
        method: 'POST',
        headers,
        body: formData,
      };

      const myRequest = new Request(restApi.loginPasswordResetMail, myInit);

      // util.customFetch사용하지 못하는 이유: result가 없음 대신 message가 있음
      window.fetch(myRequest)
        .then((response) => {
          if (response.ok) return response.json();
 		  btn.removeClass('kt-spinner kt-spinner--right kt-spinner--sm kt-spinner--light').attr('disabled', false); // remove
          throw new Error('Network response was not ok.');
        })
        .then((data) => {
          if ((data.message).includes('does not exist')) {
            btn.removeClass('kt-spinner kt-spinner--right kt-spinner--sm kt-spinner--light').attr('disabled', false); // remove
            form.clearForm(); // clear form
            form.validate().resetForm(); // reset validation states

            showErrorMsg($('.kt-findPwd'), 'danger', `해당 계정 정보를 찾을 수 없습니다.<br> 입력정보가 정확한지 확인하고 다시 시도하세요.`);
          } else {
            // similate 2s delay
            new Promise((resolve) => {
              btn.removeClass('kt-spinner kt-spinner--right kt-spinner--sm kt-spinner--light').attr('disabled', false); // remove
              form.clearForm(); // clear form
              form.validate().resetForm(); // reset validation states

              // display signup form
              /*   displaySignInForm();
              const signInForm = login.find('.kt-login__signin form');
              signInForm.clearForm();
              signInForm.validate().resetForm(); */
              $('.kt-findPwd').hide();
              resolve();
            }).then(() => {
              $('.kt-login__desc').append(`<div class="kt-portlet__body">
              <div class="form-group form-group-last">
              <div class="alert alert-secondary" role="alert">
                <div class="alert-icon"><i class="flaticon-warning kt-font-brand"></i></div>
                <div class="alert-text">
                  메일이 정상 발송되었습니다.메일로 발송된 링크로 접속해주세요!
                </div>
              </div>
            </div>
            </div>`);
            });
          }
        }).catch(e => util.swalError(`${e} <br> <a href="https://support.fitcloud.co.kr">Support Desk</a>( support@saltware.co.kr )로 <br> 문의하여 주시기 바랍니다.`));
    });
  };

  const elementInit = () => {
    $('#mfa_generate_link').on('click', () => {
      // OTP Secret 발급
      generateSecret();
    });
  }

  // Public Functions
  return {
    // public functions
    init() {
      handleFormSwitch();
      handleSignInFormSubmit();
      handleMfaFormSubmit();
      handleSignUpFormSubmit();
      handleForgotFormSubmit();
      elementInit();
    },
  };
})();

// document ready action
document.addEventListener('DOMContentLoaded', () => {
  $('#kt_login_signin_submit').removeAttr('disabled');
  KTLoginGeneral.init();
});
